import React from 'react';
import styled from '@emotion/styled';

import Button from '../../../common/Button';
import Radios from '../../../common/Radios';
import { PHYSICAL_SET_ORDER_ACTION_TYPES } from '../../../../config';
import { Link } from 'react-router-dom';
import { getYandexStoreImageMin } from '../../../../helpers';
import QuantityPicker from '../../../common/QuantityPicker';
import Select from '../../../common/Select';

const PageTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  .fe-x {
    font-size: 16px;
  }
`;

const Wrapper = styled('div')`
  .chosen-card {
    margin: 10px 15px;
    .item-inner-table {
      margin-bottom: 10px;
    }
    .image-block {
      height: 40px;
      width: 40px;
      margin-right: 15px;
      background-repeat: no-repeat;
      background-size: contain;
      flex: none;
    }
    .title {
      margin-bottom: 10px;
    }
    .shortName {
      color: #343a40;
      font-weight: bold;
    }
  }
  margin: 0 -20px;
  .card-body {
    padding: 20px 10px;
  }
  .action-types-wrapper {
    margin-left: 42px;
    margin-top: 10px;
  }

  .set-choosing {
    margin-left: 42px;
    margin-top: 10px;
    padding-bottom: 50px;
    cursor: pointer;
    color: #7e57c2;
  }

  .image-td {
    width: 35px;
    padding-right: 5px !important;
    padding-left: 5px !important;
    .image-block {
      width: 45px !important;
      height: 45px !important;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .shortname-td {
    color: #343a40;
    font-weight: bold;
    max-width: 300px;

    .ids-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }

  .set-items-wrapper {
    > div {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 10px;
      margin-bottom: 10px;
      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  }

  .quantity-picker-wrapper {
    width: 100px;
    justify-content: left;
    .quantity-static-value {
      margin-right: 5px;
      margin-left: 5px;
    }
  }

  .border-bottom {
    border-bottom: 1px solid #ebebeb;
  }

  .shortname-item {
    display: flex;
    .shortname-td {
    }
    .quantity-item {
      flex: 1;
      margin-left: 20px;
    }
  }

  .quantity-picker {
    margin: 16px 0 24px -15px;
    width: auto;

    .quantity-static-value {
      flex: none;
      color: #323a46;
    }

    .quantity-control {
      border: 1px solid #7e57c2;
      border-radius: 15px;
      height: 18px;
      width: 18px;
      display: flex;
      justify-content: center;
      margin: 0 15px;
      flex: none;

      i {
        font-size: 12px;
        margin: 0;
      }
    }
  }

  .item-inner-table {
    &:first-child {
      > td {
        border-top: none;
      }
    }
    > td {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const MobileComponent = ({
  action,
  setAction,
  currentSet,
  data,
  loading,
  handleSaveTask,
  handleChooseSets,
  quantity,
  setQuantity,
  warehouseOptions,
  warehouseCode,
  handleChangeWarehouseCode,
}) => {
  return (
    <>
      <PageTitle className="page-title">
        <h4>Новое задание</h4>
        <Link className="back-link" to="/physical-sets-journal">
          <i className="fe-x" />
        </Link>
      </PageTitle>

      <Wrapper className="card">
        <div className="card-body">
          <div className="form-inline">
            <div className="form-group">
              <span className="number-circle mr-2">1</span>
              <span>Укажите тип задания</span>
            </div>
          </div>

          <div className="action-types-wrapper">
            <Radios
              id="action"
              name="action"
              data={PHYSICAL_SET_ORDER_ACTION_TYPES}
              currentValue={action}
              onChange={setAction}
            />
          </div>

          <div className="form-inline" style={{ marginTop: '30px' }}>
            <div className="form-group">
              <span className="number-circle mr-2">2</span>
              <span>Выберите склад</span>
            </div>
          </div>
          <div className="action-types-wrapper">
            <Select
              id="warehouseCode"
              placeholder="Выберите склад"
              options={warehouseOptions}
              value={warehouseCode}
              onChange={(value) => handleChangeWarehouseCode(value)}
              isOptionDisabled={(option) => option.isOptionDisabled}
            />
          </div>

          <div className="form-inline" style={{ marginTop: '30px' }}>
            <div className="form-group">
              <span className="number-circle mr-2">2</span>
              <span>Выберите комплект и количество</span>
            </div>
          </div>
          <div>
            {currentSet ? (
              <div className="chosen-card">
                <div
                  className="chosen-card__image"
                  style={{
                    backgroundImage: `url(${getYandexStoreImageMin(
                      currentSet.images?.[0].url,
                      100,
                    )})`,
                  }}
                ></div>
                <div className="chosen-card__main">
                  <div className="border-bottom mb-3 pb-2">
                    <div className="title">Комплект</div>
                    <div className="d-flex ">
                      <div
                        className="image-block"
                        style={{
                          backgroundImage: `url(${getYandexStoreImageMin(
                            currentSet.images?.[0].url,
                            100,
                          )})`,
                        }}
                      />
                      <div className="shortName">{currentSet.shortName}</div>
                    </div>

                    <span className="ids-span">
                      {currentSet.id}
                      {currentSet?.extId ?? null}
                    </span>
                  </div>
                  <div>
                    <div className="title">Состав</div>
                    {currentSet.items.map((i, index) => (
                      <div key={i.id} className="item-inner-table border-bottom pb-1">
                        <div className="shortname-td">
                          <div className="d-flex">
                            <div
                              className="image-block"
                              style={{
                                backgroundImage: `url(${getYandexStoreImageMin(
                                  i.images?.[0].url,
                                  100,
                                )})`,
                              }}
                            />
                            <div>
                              <div>{i.shortName}</div>
                              <div className="ids-span">
                                {i.id}
                                {i?.extId ?? null}
                              </div>
                              <div className="font-weight-normal mb-1">{`Кол-во: ${i.quantity} шт`}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <QuantityPicker
                    reverse
                    value={quantity}
                    onChange={setQuantity}
                    className="quantity-picker"
                  />
                </div>
              </div>
            ) : null}
          </div>

          <div
            className={`set-choosing ${currentSet && quantity ? 'border-bottom' : ''}`}
            style={{ marginLeft: currentSet ? 0 : '' }}
            onClick={handleChooseSets}
          >
            {`${currentSet ? 'Изменить' : '+ Выбрать'} комплект`}
          </div>

          {currentSet && quantity ? (
            <Button
              text="Создать задание"
              style={{ marginTop: '20px' }}
              loading={loading}
              disabled={loading}
              onClick={handleSaveTask}
            />
          ) : null}
        </div>
      </Wrapper>
    </>
  );
};

export default MobileComponent;
